import { createHash } from "crypto";
import { getWertFromlocalStorage } from "./functions";
import { APIEnumRolle } from "../types/apiTypes";
import { useAppStore } from "../store/zustandAppStore";
import { useLogin } from "../hooks/useLogin";

/**
 * Checks on API if actual User has Roles SM or CA
 * returns boolean
 * TODO
 */
export const isSalonManagerAndAbove = () => {
  let rolle = getWertFromlocalStorage("loginInfo", "rolle");
  return (
    rolle === APIEnumRolle.APIDB_ENUM_GESCHAEFTSFUEHRUNG ||
    rolle === APIEnumRolle.APIDB_ENUM_FILIALLEITUNG ||
    rolle === APIEnumRolle.APIDB_ENUM_ADMIN
  );
};

/**
 * Checks in API if actual User has CA Role
 * returns boolean
 * TODO
 */
export const isCompanyAdministrator = () => {
  let rolle = getWertFromlocalStorage("loginInfo", "rolle");
  return rolle === APIEnumRolle.APIDB_ENUM_GESCHAEFTSFUEHRUNG || rolle === APIEnumRolle.APIDB_ENUM_ADMIN;
};

/**
 * Hashes a string in SHA256
 * @param stringGot
 * returns hashed String
 */
export const hashString = async(stringGot: string): Promise<string> => {
  //return createHash("sha256").update(stringGot).digest("hex");
  const encoder = new TextEncoder();
  const data = encoder.encode(stringGot);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

